import axios, { AxiosPromise } from 'axios';
import { XsrfToken } from 'Roblox';
import RequestConfig from '../interfaces/RequestConfig';
import ErrorResponse from '../interfaces/ErrorResponse';
import HttpResponseCodes from './httpResponseCodes';
import HttpRequestMethods from './httpRequestMethods';

const CSRF_TOKEN_HEADER = 'x-csrf-token';
const CSRF_INVALID_RESPONSE_CODE = HttpResponseCodes.forbidden;

// TODO: figure out how to get theres from data attr on page #http-retry-dat
const HTTP_RETRY_BASE_TIMEOUT = 1000;
const HTTP_RETRY_MAX_TIMEOUT = 8000;
const HTTP_RETRY_MAX_TIMES = 3;

let currentToken = XsrfToken.getToken();

axios.interceptors.request.use((config: RequestConfig) => {
  const { method, noCache, headers } = config;
  const newConfig = Object.assign({}, config);
  // if type is post or delete add XsrfToken to header.
  if (
    method === HttpRequestMethods.POST ||
    method === HttpRequestMethods.PATCH ||
    method === HttpRequestMethods.DELETE
  ) {
    if (!currentToken) {
      currentToken = XsrfToken.getToken();
    }
    if (noCache) {
      newConfig.headers = headers || {};
      newConfig['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      newConfig.Pragma = 'no-cache';
      newConfig.Expires = 0;
    }
    newConfig.headers[CSRF_TOKEN_HEADER] = currentToken;
  }
  return newConfig;
}, null);

axios.interceptors.response.use(
  null,
  (error: ErrorResponse): AxiosPromise => {
    const { response } = error;
    if (response) {
      const { status, headers, config } = response;
      const newToken: string = headers[CSRF_TOKEN_HEADER];

      if (status === CSRF_INVALID_RESPONSE_CODE && newToken) {
        config.headers[CSRF_TOKEN_HEADER] = newToken;
        currentToken = newToken;
        XsrfToken.setToken(newToken);
        return axios.request(config);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
